module.exports = __webpack_public_path__ + "img/cloudpod_login_logo.1280098d.svg";